export const COST_CENTERS = [
  "02 - Labor",
  "03 - Equipment",
  "04 - Material",
  "05 - Subcontratos",
  "06 - Other",
  "07 - Chiveros",
];

export const EXPENSE_CATEGORIES = [
  "Travel & Transportation",
  "Meals & Entertainment",
  "Software & Subscriptions",
  "Office Supplies",
  "Hardware & Equipment",
  "Training & Education",
  "Marketing & Advertising",
  "Professional Services",
  "Utilities",
  "Other",
];

// ── Single source of truth for status colors — Gastos + Nómina (V34.1) ──
// `color` = strong (dot / text / badge border); `bg` = light badge fill. Change a color HERE and
// every legend, badge, calendar cell, and chip across both modules updates. Labels live in
// STATUS_LABEL (Gastos) and the per-page configs (Nómina) — this file owns colors only.
export const STATUS_STYLE = {
  draft:               { color: "#7c3aed", bg: "#f3e8ff" },  // Borrador / Sin Enviar — purple
  pending:             { color: "#eab308", bg: "#fef9c3" },  // En Revisión — yellow
  submitted:           { color: "#eab308", bg: "#fef9c3" },  // Sometido (pass-through) — yellow
  pending_engineer:    { color: "#eab308", bg: "#fef9c3" },  // Pend. Ingeniero — yellow
  pending_manager:     { color: "#b45309", bg: "#fef3c7" },  // Pend. Gerente — mustard
  pending_clerk:       { color: "#2563eb", bg: "#dbeafe" },  // Rev. Final — blue (off green)
  pending_review:      { color: "#2563eb", bg: "#dbeafe" },  // Pend. de Revisión (Gastos) — blue
  partially_approved:  { color: "#60a5fa", bg: "#eff6ff" },  // Parc. Aprobado — lighter blue
  approved:            { color: "#16a34a", bg: "#dcfce7" },  // Aprobado — green
  returned:            { color: "#ea580c", bg: "#ffedd5" },  // Devuelto (Nómina) — orange
  sent_back:           { color: "#ea580c", bg: "#ffedd5" },  // Devuelto (Gastos) — orange
  partially_returned:  { color: "#ea580c", bg: "#ffedd5" },  // Parc. Devuelto — orange
  rejected:            { color: "#dc2626", bg: "#fee2e2" },  // Rechazado — red
  paid:                { color: "#475569", bg: "#f1f5f9" },  // Pagado — slate (off green-teal)
  no_card:             { color: "#94a3b8", bg: "#f1f5f9" },  // "Sin tarjeta" (Nómina calendar only)
};

// Gastos badge shape ({ bg, text, border }) derived from STATUS_STYLE — strong color drives both
// text and border. Kept so existing consumers (AdminDashboard, ReceiptViewerModal, etc.) don't break.
export const STATUS_COLORS = Object.fromEntries(
  Object.entries(STATUS_STYLE).map(([k, s]) => [k, { bg: s.bg, text: s.color, border: s.color }])
);

export const STATUS_LABEL = {
  draft:               'Sin Enviar',
  pending:             'Pendiente',
  sent_back:           'Devuelto',
  approved:            'Aprobado',
  rejected:            'Rechazado',
  partially_approved:  'Parcialmente Aprobado',
  partially_returned:  'Parcialmente Devuelto',
  pending_review:      'Pendiente de Revisión',
  paid:                'Pagado',
};

export const REJECTION_REASONS = [
  "Recibo faltante o ilegible",
  "Gasto personal — no elegible para reembolso",
  "Envío duplicado",
  "Monto excede el límite de la política",
  "Fuera de la categoría de gastos aprobada",
  "Fecha del recibo fuera del período permitido",
  "Otro",
];

export const PAYMENT_METHODS = {
  credit_card: 'Tarjeta de Crédito',
  petty_cash: 'Petty Cash',
};

export const PR_TAX_RATES = [
  { value: 11.5, label: '11.5% — IVU Estándar' },
  { value: 7,    label: '7% — IVU Reducido (Alimentos)' },
  { value: 4,    label: '4% — B2B (Servicios)' },
  { value: 0,    label: '0% — Exento' },
];

// Unpaid absence reasons (Nómina V25)
// Paid absences keep using cost codes (01102/01104/01107/01108/01109/01110).
export const ABSENCE_REASONS = {
  class:    'Clase',
  absence:  'Ausencia',
  personal: 'Personal',
};

export const SENDBACK_REASONS = [
  "Información del proveedor incompleta",
  "Monto poco claro o faltante",
  "Fecha faltante o incorrecta",
  "Categoría o centro de costo requiere corrección",
  "Descripción insuficiente",
  "Documentación adicional requerida",
  "Otro",
];
